// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"9df8cc3b","141":"3c0ae10a","234":"ee1cb63e","747":"f037bb70","985":"e9afc85f"}[chunkId] + ".chunk.css";
};